export const setProperty = (cssVar, value) => document.documentElement.style.setProperty(cssVar, value)

export const setPropertyPx = (cssVar, value) => setProperty(cssVar, value + "px");

const MONTHS = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
]

export const month = (no) => MONTHS[no - 1]

export const ordinal = (no) => {
    if (no === 2)
        return "nd"
    if (no === 3)
        return "rd"
    if (no % 10 === 1 && no % 100 !== 1) {
        return "st"
    }
    return "th"
}
